import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import DeleteIcon from '@mui/icons-material/Delete'
import { capitalize, noop } from 'lodash'
import { Logger, toDollars } from '@wolfdanepug/common-react'
import { convertToEnglishWordList } from '../../utils'

export default function OrderItem({ item, onClick = noop, deleteEnabled = false }: any) {
	Logger.log('[OrderItem] item', item)
	const types = item.meta.products.map((product: any) => capitalize(product.meta.category))
	return (
		<>
			<Grid item xs={9}>
				<Typography variant="body2">{item.meta.name}'s Gourmet Fresh</Typography>
				<Typography variant="caption">
					First 14 day gourmet box{' '}
					<Box component={'span'} sx={{ color: 'primary.main' }}>
						({convertToEnglishWordList(types)})
					</Box>
				</Typography>
			</Grid>
			<Grid item xs={3} textAlign={'right'}>
				<Box
					component={'span'}
					sx={{
						position: 'relative',
						display: 'block',
						'&:hover': {
							'& button': { display: 'block' }
						}
					}}
				>
					{deleteEnabled && (
						<IconButton
							size="small"
							sx={{
								position: 'absolute',
								top: '50%',
								left: 0,
								p: 0,
								m: 0,
								transform: 'translateY(-50%)',
								display: { xs: 'none', md: 'none' }
							}}
							onClick={onClick}
						>
							<DeleteIcon />
						</IconButton>
					)}
					<Typography variant="body2">$ {toDollars(item?.price)}</Typography>
				</Box>
			</Grid>
		</>
	)
}
